import { normalizeChainIdAsNumber } from '@avantarte/smart-contracts/utilities/createEthersRpcProvider';

import { SimpleChainIdType } from '../../types/web3/product';
import { ChainId, ErcChainId, ErcChainName } from '../../types/web3/web3';

const chainNames: Record<ErcChainId, ErcChainName> = {
  '0x0': 'hardhat (local)',
  '0x1': 'ethereum mainnet',
  '0x5': 'ethereum goerli',
  '0x137': 'polygon mainnet',
  '0x80001': 'polygon mumbai',
  '0x11155111': 'ethereum sepolia',
};

export const isMainnet = (chainId: ChainId) => {
  return [1, 137].includes(normalizeChainIdAsNumber(chainId));
};

export const isEthereum = (chainId: ChainId) => {
  return [1, 5, 11155111].includes(normalizeChainIdAsNumber(chainId));
};
export const isPolygon = (chainId: ChainId) => {
  const chain = getSimpleChainName(chainId);
  return chain === 'polygon';
};

// converts chain id to chain name
export const getChainName = (
  chainId: SimpleChainIdType | ErcChainId,
): ErcChainName => {
  return chainNames[getErcChainId(chainId)!];
};

// converts chain id to simple chain name
export const getSimpleChainName = (
  chainId: SimpleChainIdType | ErcChainId,
): string => {
  return chainNames[getErcChainId(chainId)!]?.split(' ')[0];
};

// normalizes chain number like (1,2,3,0x01,0x05,0x137) to chain id like (0x1,0x2,0x3)
export const getErcChainId = (id: ChainId | string): ErcChainId | undefined => {
  if (!id) {
    return undefined;
  }
  if (id === 'ethereum') {
    return '0x1';
  }

  return `0x${normalizeChainIdAsNumber(id)}` as ErcChainId;
};

export const isSameChainId = (id1: ChainId, id2: ChainId) => {
  return getErcChainId(id1) === getErcChainId(id2);
};
